/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AlertMessageCreate } from '../models/AlertMessageCreate';
import type { AlertMessageDetails } from '../models/AlertMessageDetails';
import type { AlertMessageUpdate } from '../models/AlertMessageUpdate';
import type { PagedItems } from '../models/PagedItems';
import type { PagingQuery } from '../models/PagingQuery';
import { request as __request } from '../core/request';

export class AlertMessagesVService {

    /**
     * @param requestBody
     * @returns PagedItems OK
     * @throws ApiError
     */
    public static async alertMessagesVGetAll(
        requestBody?: PagingQuery,
    ): Promise<PagedItems> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/Alert_Messages/get`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns AlertMessageDetails OK
     * @throws ApiError
     */
    public static async alertMessagesVGetExport(
        requestBody?: PagingQuery,
    ): Promise<AlertMessageDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/Alert_Messages/export`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns AlertMessageDetails Created
     * @throws ApiError
     */
    public static async alertMessagesVCreate(
        requestBody?: AlertMessageCreate,
    ): Promise<AlertMessageDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/Alert_Messages`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param alertMessageId
     * @param requestBody
     * @returns AlertMessageDetails OK
     * @throws ApiError
     */
    public static async alertMessagesVUpdate(
        alertMessageId: string,
        requestBody?: AlertMessageUpdate,
    ): Promise<AlertMessageDetails> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/v2/Alert_Messages/${alertMessageId}`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param alertMessageId
     * @returns any No Content
     * @throws ApiError
     */
    public static async alertMessagesVDelete(
        alertMessageId: string,
    ): Promise<any> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/v2/Alert_Messages/${alertMessageId}`,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

}